import React, { useEffect, useState } from "react";
import axios from "../../axios/AxiosInstance";
import ClientDetail from "../../pages/ClientDetail";
export default function ProspectingClientEditor({ clientId, onClose, onUpdated }) {
  const [client, setClient] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    axios.get(`client/${encodeURIComponent(clientId)}`).then(({data}) => { if(active) setClient(data); })
      .catch(() => { if(active) setError("Impossible de charger la fiche client. Réessayez."); });
    return () => { active = false; };
  }, [clientId]);
  if (!client) return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-white/90"><div role={error ? "alert" : "status"}>{error || "Chargement de la fiche client…"}<button className="ml-4 underline" onClick={onClose}>Fermer</button></div></div>;
  return <ClientDetail client={client} initialEditing clients={[client]} originalClients={[client]} setClients={() => {}}
    setClient={updated => { if(!updated) {onClose();return;} setClient(updated); onUpdated(updated); }} />;
}
